import { ADD_SINDROME_ANALISIS, DELETE_SINDROME_ANALISIS } from "./types";

export const agregarSindromeAnalisis = (codSintoma) => {
  return { type: ADD_SINDROME_ANALISIS, payload: codSintoma };
};

export const borrarSindromeAnalisis = (codSintoma) => {
  return { type: DELETE_SINDROME_ANALISIS, payload: codSintoma };
};
